import { render, staticRenderFns } from "./form.vue?vue&type=template&id=b625d6bc"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b625d6bc')) {
      api.createRecord('b625d6bc', component.options)
    } else {
      api.reload('b625d6bc', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=b625d6bc", function () {
      api.rerender('b625d6bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/blog/form.vue"
export default component.exports